'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = parse;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokens = (0, _create2.default)(null);

tokens['_'] = {
    token: '_',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.underline;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.underline === true) {
            return -1;
        }

        if (pos > 0 && inp[pos - 1] !== ' ') {
            return -1;
        }

        if (inp.substr(pos + 1).indexOf(this.token) === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.underline = true;
        block.content += this.token;

        return null;
    }
};
tokens['*'] = {
    token: '*',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.bold;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.bold === true) {
            return -1;
        }

        if (inp[pos - 1] === ':') {
            return -1;
        }

        if (pos > 0 && inp[pos - 1] !== ' ') {
            return -1;
        }

        var remainingText = inp.substr(pos + 1);
        var nextPos = remainingText.indexOf(this.token);
        if (nextPos === -1 || nextPos < remainingText.length - 1 && remainingText[nextPos + 1] !== ' ') {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.bold = true;
        block.content += this.token;

        return null;
    }
};
tokens['**'] = {
    token: '**',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.italic;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.italic === true) {
            return -1;
        }

        if (inp.substr(pos + 1).indexOf(this.token) === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.italic = true;
        block.content += this.token;

        return null;
    }
};
tokens['`'] = {
    token: '`',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.quote;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        var str = inp.substr(pos + 1);
        var endPos = str.indexOf(this.token);
        if (endPos === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.quote = true;
        block.content += this.token + str.substr(0, endPos);
        block.containsContent = true;

        return pos + endPos + 1;
    }
};

tokens['\x02'] = {
    token: '\x02',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.bold;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.bold = true;
        }

        return null;
    }
};

tokens['\x1D'] = {
    token: '\x1D',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.italic;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.italic = true;
        }

        return null;
    }
};

tokens['\x1F'] = {
    token: '\x1F',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.underline;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.underline = true;
        }

        return null;
    }
};

tokens['\x0F'] = {
    token: '\x0F',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        (0, _keys2.default)(block.styles).forEach(function (k) {
            return delete block.styles[k];
        });
        (0, _keys2.default)(openToks).forEach(function (k) {
            return delete openToks[k];
        });

        return null;
    }
};

tokens['\x03'] = {
    token: '\x03',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        var colours = {
            0: 'white',
            1: 'black',
            2: 'blue',
            3: 'green',
            4: 'light-red',
            5: 'brown',
            6: 'purple',
            7: 'orange',
            8: 'yellow',
            9: 'light-green',
            10: 'cyan',
            11: 'light-cyan',
            12: 'light-blue',
            13: 'pink',
            14: 'grey',
            15: 'light-grey'
        };

        var colourMatchRegexp = /^\x03(([0-9][0-9]?)(,([0-9][0-9]?))?)/;
        var match = colourMatchRegexp.exec(inp.substr(pos, 6));
        if (match) {
            var fgColour = colours[parseInt(match[2], 10)];
            var bgColour = colours[parseInt(match[4], 10)];
            if (typeof fgColour !== 'undefined') {
                block.styles.color = fgColour;
            }
            if (typeof bgColour !== 'undefined') {
                block.styles.background = bgColour;
            }

            return pos + match[0].length;
        }

        delete block.styles.color;
        delete block.styles.background;

        return null;
    }
};

function parse(inp, _opts) {
    var opts = _opts || {};
    var block = createNewBlock();
    var blocks = [block];
    var openTokens = (0, _create2.default)(null);

    var pos = 0;
    var len = inp.length;

    while (pos < len) {
        var tok = findTokenAtPosition();
        if (!tok || !opts.extras && tok.extra) {
            block.content += inp[pos];
            block.containsContent = true;
            pos++;
            continue;
        }

        var newBlock = null;

        if (block.containsContent) {
            newBlock = createNewBlock();
        } else {
            newBlock = block;
        }

        (0, _assign2.default)(newBlock.styles, block.styles);
        var newPos = tok.fn(inp, pos, newBlock, block, openTokens);

        if (newPos === -1) {
            block.content += tok.token;
            block.containsContent = true;
            pos += tok.token.length;
            continue;
        }

        block = newBlock;

        if (blocks[blocks.length - 1] !== newBlock) {
            blocks.push(newBlock);
        }

        if (typeof newPos === 'number') {
            pos = newPos;
        } else {
            pos += tok.token.length;
        }
    }

    return blocks;

    function findTokenAtPosition() {
        var tok = tokens[inp.substr(pos, 2)] || tokens[inp[pos]];
        return tok;
    }

    function createNewBlock() {
        var newBlock = {
            styles: {},
            content: '',
            containsContent: false
        };
        return newBlock;
    }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["MessageFormatter"]
window._kiwi_exports.libs.MessageFormatter = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/MessageFormatter.js
// module id = c8bq
// module chunks = 1